import { Component } from '@angular/core';

import { BetslipOverAskPickOptionMarketBaseComponent } from '../../betslip-over-ask-pick-option-market-base.component';

@Component({
    selector: 'bs-betslip-over-aks-pick-option-market',
    templateUrl: './betslip-over-ask-pick-option-market.component.html',
    styleUrls: ['./betslip-over-ask-pick-option-market.component.scss'],
    standalone: false,
})
export class BetslipOverAskPickOptionMarketComponent extends BetslipOverAskPickOptionMarketBaseComponent {}
